import {useQuery} from '@tanstack/react-query'
import {envVars} from '@/envVars'
import {QUERY_KEYS} from '@/queryClient'
import {linearProjectIssues} from '../services/linear.http'

export const useGetLinearIssues = ({enabled}: {enabled: boolean}) =>
    useQuery({
        queryKey: [QUERY_KEYS.LINEAR_PROJECT_ISSUES, envVars.VITE_LINEAR_PROJECT_ID],
        queryFn: () => linearProjectIssues(envVars.VITE_LINEAR_PROJECT_ID),
        enabled,
        // The history reflects work picked up by the dev team — keep it reasonably fresh.
        staleTime: 60000
    })
